<template>
    <div class="history-modal-item-component">
        <SelectModal
            v-if="selectModal.open"
            translation-base=""
            :title="selectModal.title"
            :selected-id="selectModal.selectedId"
            :list="selectModal.data"
            @select-item="handleSelectModalClick"
            @close="selectModal.open = false"
        />
        <InputModal
            v-if="inputModal"
            :data="selectedFieldInputModal"
            :isCustomFields="true"
            @setQuantityValue="(context) => setValueInputModal(context)"
            @close="(title) => handleInputModal(title, 'close')"
        />
        <div class="profile-info">
            <div class="picture">
                <img
                    v-if="item.userPhotoUrl"
                    :src="item.userPhotoUrl"
                    alt="User photo"
                />
                <AvatarPlaceholder
                    v-else
                    size="38px"
                    :text="picturePlaceholder"
                />
            </div>
            <div class="name">
                {{ `${item.firstName} ${item.lastName}` }}
            </div>
        </div>
        <div
            v-if="currentTab === 'stops'"
            class="stops-items"
        >
            <div class="status-block cursor-pointer">
                <div class="label">Status <EditIcon @click="handleSelectModal(item)" /></div>
                <div class="value">{{ item.statusName }}</div>
            </div>
            <div class="date-block">
                <div class="label">{{ $t("OperationProgress.Date") }}</div>
                <div class="value">{{ formatDate(item.eventTime) }}</div>
            </div>
            <div class="shift-block">
                <div class="label">{{ $t("Operator.Shift") }}</div>
                <div class="value">{{ item.turnoName }}</div>
            </div>
            <div class="time-block">
                <div class="label">{{ $t("IntegrationPage.Time") }}</div>
                <div class="value">{{ formatDurationHms(item.timeInSeconds, "seconds") }}</div>
            </div>
        </div>
        <div
            v-else
            class="quantity-items"
        >
            <div class="prod-qty-block">
                <div class="label">
                    {{ $t("QtyProd") }}
                    <EditIcon @click="handleInputModal('QtyProd', 'open', item)" />
                </div>
                <div class="value">{{ item.qtdProd }}</div>
            </div>
            <div class="refuse-block">
                <div class="label">
                    {{ $t("OperationProgress.Refuse") }}
                    <EditIcon @click="handleInputModal('OperationProgress.Refuse', 'open', item)" />
                </div>
                <div class="value">{{ item.refuse }}</div>
            </div>
            <div v-if="item.refuse > 0" class="refuse-reason-block">
                <div class="label">{{ $t("ProductionProgress.ReasonsForRejection") }}</div>
                <div class="value">{{ item.refuseReason }}</div>
            </div>
            <div class="rework-block">
                <div class="label">
                    {{ $t("OperationProgress.Rework") }}
                    <EditIcon @click="handleInputModal('OperationProgress.Rework', 'open', item)" />
                </div>
                <div class="value">{{ item.rework }}</div>
            </div>
            <div class="date-block">
                <div class="label">{{ $t("OperationProgress.Date") }}</div>
                <div class="value">{{ formatDate(item.eventTime) }}</div>
            </div>
            <div class="shift-block">
                <div class="label">{{ $t("Operator.Shift") }}</div>
                <div class="value">{{ item.turnoName }}</div>
            </div>
            <div class="time-block">
                <div class="label">{{ $t("IntegrationPage.Time") }}</div>
                <div class="value">{{ formatDurationHms(item.timeInSeconds, "seconds") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { avatarText } from "@core/utils/filter";
    import AvatarPlaceholder from "@/@core/components/avatar-placeholder/index.vue";
    import EditIcon from "@/assets/images/icons/edit-icon-small.svg";
    import InputModal from "@/views/pages/operator/components/InputModal/InputModal.vue";
    import SelectModal from "@/views/pages/operator/components/SelectModal/SelectModal.vue";
    import { mapMutations } from "vuex";
    import moment from "moment";
    import { formatDurationHms } from "@/views/pages/operator/utils";

    export default {
        components: { AvatarPlaceholder, EditIcon, InputModal, SelectModal },
        props: {
            item: {
                type: Object,
                default: () => {}
            },
            statusList: {
                type: Array,
                default: () => {}
            },
            currentTab: {
                type: String,
                default: "stops"
            }
        },
        data() {
            return {
                inputModal: false,
                selectedFieldInputModal: {
                    title: "",
                    quantityProp: 0,
                    id: null
                },
                selectModal: {
                    selectedId: null,
                    open: false,
                    title: "",
                    data: []
                }
            };
        },
        mounted() {},
        methods: {
            ...mapMutations("app", ["UPDATE_FLAG_SHOW_OVERLAY"]),
            formatDurationHms,
            setValueInputModal(context) {
                const { title, quantity } = context;
                if (title === "Retrabalho" || title === "Rework") {
                    this.editItem(undefined, undefined, undefined, quantity);
                }
                if (title === "Refugo" || title === "Refuse") {
                    this.editItem(undefined, undefined, quantity);
                }
                if (title === "Qtd. Prod" || title === "Qty. Prod") {
                    this.editItem(undefined, quantity);
                }
            },
            handleInputModal(fieldTitle, action = "open", item) {
                const props = action === "open" && {
                    title: this.$t(fieldTitle),
                    quantityProp: item.quantity
                };

                this.selectedFieldInputModal = action === "open" ? props : {};
                this.inputModal = action === "open";
            },
            handleSelectModal(item) {
                this.selectModal = {
                    selectedId: item.statusId || null,
                    open: true,
                    title: "Status",
                    data: this.statusList
                };
            },
            handleSelectModalClick(value) {
                const statusId = value.item.id;
                this.editItem(statusId);
            },
            formatedNumber(value) {
                if (typeof value !== "string") return value;
                const cleaned = value.replace(/\./g, "").replace(",", ".");
                return parseFloat(cleaned);
            },
            editItem(
                statusId = this.item.statusId,
                qtdProd = this.item.qtdProd,
                refuse = this.item.refuse,
                rework = this.item.rework
            ) {
                const payload = {
                    producedQuantity: this.formatedNumber(qtdProd),
                    refuse: this.formatedNumber(refuse),
                    rework: this.formatedNumber(rework),
                    statusId: statusId
                };
                this.UPDATE_FLAG_SHOW_OVERLAY(true);
                this.$http2
                    .put(
                        `/api/mysfc/operation-progress/update-history-stop/${this.item.id}`,
                        payload
                    )
                    .then(() => {
                        this.UPDATE_FLAG_SHOW_OVERLAY(false);
                        this.$emit("updateList");
                    });
            },
            formatDate(date) {
                const language = this.$cookies.get("userInfo").language;

                if (language == "pt-BR") return moment(date).format("DD-MM-YYYY");
                else return moment(date).format("MM-DD-YYYY");
            }
        },
        computed: {
            picturePlaceholder() {
                return avatarText(this.item.firstName, this.item.lastName);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .history-modal-item-component {
        border-radius: 24px;
        border: 1px solid #cfc4be;

        .profile-info {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px 24px;
            border-bottom: 1px solid #cfc4be;

            .picture {
                height: 100%;
                display: flex;
                align-items: center;
                padding: 9px;
            }

            img {
                width: 30px;
                height: 30px;
                object-fit: cover;
                border-radius: 100%;
            }

            .name {
                color: #4c4541;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px; /* 162.5% */
            }
        }

        .stops-items,
        .quantity-items {
            display: flex;
            padding: 24px;

            .status-block,
            .date-block,
            .shift-block,
            .time-block,
            .prod-qty-block,
            .refuse-block,
            .refuse-reason-block,
            .rework-block,
            .date-block,
            .shift-block,
            .time-block {
                width: 100%;
                text-align: center;

                .label {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    color: #998f8a;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px; /* 142.857% */

                    svg {
                        cursor: pointer;
                    }
                }

                .value {
                    color: #4c4541;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 26px; /* 162.5% */
                }
            }
        }
    }
</style>
